import React from 'react';
import * as XLSX from 'xlsx';

const DownloadExcelByTableId = ({ tableIds ,name}) => {
  const handleDownload = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    tableIds.forEach((tableId) => {
      const tableElement = document.getElementById(tableId);
      if (tableElement) {
        // Convert table HTML to a worksheet
        const worksheet = XLSX.utils.table_to_sheet(tableElement);
        // Append the worksheet to the workbook with the table ID as the sheet name
        XLSX.utils.book_append_sheet(workbook, worksheet, tableId);
      }
    });

    // Export the workbook
    XLSX.writeFile(workbook, "Tables.xlsx");
  };

  return (
    <div>
      {/* <div className="uiverse m-0 " onClick={() =>
      handleDownload("TracibilityReport2")}>
    <span className="tooltip">Dowload Excel File</span>
    <span>
    Download
    </span>
</div> */}
      <button className='btn-sm btn-primary' onClick={handleDownload}>{name && name ?name :'Download Excel'}</button>
    </div>
  );
};

export default DownloadExcelByTableId;
